import type { ActivityTimeseriesPoint } from "@/lib/api";

/**
 * Dependency-free bar chart of daily activity. Each bar's height is the total
 * number of events that day; the darker portion is the share that were logins.
 */
export function ActivityChart({ data }: { data: ActivityTimeseriesPoint[] }) {
  const max = Math.max(1, ...data.map((d) => d.events));

  return (
    <div className="flex h-40 items-stretch gap-1">
      {data.map((point) => (
        <div key={point.day} className="group relative flex flex-1 flex-col justify-end">
          <div
            className="bg-accent/20 relative w-full rounded-t"
            style={{ height: `${Math.max(2, (point.events / max) * 100)}%` }}
          >
            <div
              className="bg-accent absolute inset-x-0 bottom-0 rounded-t"
              style={{
                height: `${point.events ? (point.logins / point.events) * 100 : 0}%`,
              }}
            />
          </div>
          <span className="bg-foreground text-background pointer-events-none absolute -top-7 left-1/2 z-10 hidden -translate-x-1/2 rounded-sm px-1.5 py-0.5 text-[10px] whitespace-nowrap group-hover:block">
            {point.day}: {point.events} events · {point.logins} logins
          </span>
        </div>
      ))}
    </div>
  );
}
